var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-sub-title',{attrs:{"text":"Opciones del Menú"}}),_vm._v(" "),_c('app-menu-form-filters',{attrs:{"menus":_vm.menus},on:{"filter":_vm.onFilterProfiles}}),_vm._v(" "),_c('app-menu-options-list',{attrs:{"data":_vm.data,"on-change-page":_vm.onChangePage},on:{"add-menu":_vm.addMenu,"sort":_vm.onSort}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }